import { useState, useEffect, useMemo,useRef  } from 'react';

import api from '../../apis';
import moment from 'moment';
import { usePagination } from './helper';

import ReactTable from '../general/form-control/react-table';
import { useFilter } from '../../context/FilterContext';
import { numberWithCommas } from '../general/convertor';
import { Button } from 'antd';

const PurchaseSalesTbl = ({
    //accounts = []
    inputs={},
    settlementType = null
}:any) => {
    const { tablePagination, setTablePagination } = usePagination();
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [accounts, setAccounts] = useState([]);
    const [_inputs, _setInputs] = useState({});
    const [summary, setSummary] = useState(null);

    const { filterParams,setFilterParams } = useFilter();
    // Using useRef to store the latest _filterParams
    const filterParamsRef = useRef(filterParams);

    useEffect(() => {
        handleFilter(filterParams)
    }, [filterParams]);



    const handleFilter = (filterParams:any)=>{
        if(Object.keys(filterParams).length == 0) return;

        let accounts = filterParams["accounts[]"] ||[];
        requestTableData(accounts,1,filterParams);
        requestSummary(accounts,1,filterParams);
        _setInputs(filterParams);
        setAccounts(accounts);

        filterParamsRef.current = filterParams;
 
    }
 

    const requestTableData = async (accounts:string[],cPage=1,inputs:any={}) =>{
        if(accounts.length <1) {
            setTableData([])
            return 
        }

       // if(!orderNo)return;
        setLoading(true)

        if(settlementType){
            inputs['settlementType'] = settlementType;
        }
        let result = await api.getMultiAccountContract(accounts, inputs,cPage);
      //  console.log("getMultiAccountContract",result)
 
        if(result.contracts){
            setTableData(result.contracts)
        }else{
            setTableData([])
        }

        
        if (result.total) {
            // handlePagination('currentPage', cPage);
            // handlePagination('totalRecords', result.total);
            setTablePagination({
                currentPage: cPage,
                totalRecords: result.total
            });
        }

        
       setLoading(false)
        // console.log("getTradeHistoryLogs",result)
    }

    const requestSummary = async (accounts:string[],cPage=1,inputs:any={}) =>{
        setSummary(null);
        let summary = await api.getAccountContractSummary(accounts[0],inputs);
       // console.log('summary',summary)
        if(summary){
            setSummary(summary);
        }

    }

    const tblColumns = useMemo(
        () => [
            {
                Header: 'Date',
                accessor: 'datetime',
                
                rowSpan: '2',
                columns: [
                    {
                        Header: 'noneBlock1',
                        accessor: 'ctrt_contractdate',
                        Cell: (data: any) => {
                            if(!data.value) return;
                            return moment(data.value).format('yyyy-MM-DD HH:mm:ss');
                        },
                        displayNone: true,
                    },
                ]
            },
            {
                Header: 'Contract No',
                accessor: 'ctr_contrano',
                rowSpan: '2',
                
                columns: [
                    {
                        Header: 'noneBlock2',
                        accessor: 'ctrt_contractno',
                        displayNone: true,
                        Cell: (data: any) => {
                            if(!data.value) return;
                            return <div className='cursor-pointer'  onClick={()=>handleOpenFile(data.row.original)}><u>{data.value}</u></div>;
                        },
                    },
                ]
            },
            {
                Header: 'Due / Delivery Date',
                accessor: 'delievery_date',
                rowSpan: '2',
                columns: [
                    {
                        Header: 'noneBlock3',
                        accessor: 'ctrt_duedate',
                        Cell: (data: any) => {
                            if(!data.value) return;
                            return moment(data.value).format('yyyy-MM-DD HH:mm:ss');
                        },
                        displayNone: true
                    },
                ]
            },
            {
                Header: 'Stock',
                accessor: 'stock',

                columns: [
                    {
                        Header: 'Code',
                        accessor: 'ctrt_stockcode',
                      },
                      {
                        Header: 'Name',
                        accessor: 'ctrt_stockname',
                      },
                ],
            },
            {
                Header: 'Quantity',
                rowSpan: '2',
                accessor: 'quantity',
                columns: [
                    {
                        Header: 'noneBlock31',
                        accessor: 'ctrt_quantity',
                        displayNone: true,
                        Cell: (v: any) => {
                                return (
                                    <div className="text-right">
                                        {numberWithCommas(v.value, 0)}
                                    </div>
                                );
                        }
                    },
                ]
            },
            {
                Header: 'Price',
                accessor: '',
                rowSpan: '2',
                columns: [
                    {
                        Header: '',
                        accessor: 'ctrt_price',
                        displayNone: true,
                        Cell: (v: any) => {
                                return (
                                    <div className="text-right">
                                        {numberWithCommas(v.value, 2)}
                                    </div>
                                );
                        }
                    },
                ]
            },
            {
                Header: 'Currency',
                accessor: '',
                rowSpan: '2',
                columns: [
                    {
                        Header: '',
                        accessor: 'c_code',
                        displayNone: true
                    },
                ]
            },
            {
                Header: 'Amount',
                accessor: '',
                rowSpan: '2',
                columns: [
                    {
                        Header: '',
                        accessor: 'ctrt_value',
                        displayNone: true,
                        Cell: (v: any) => {
                                return (
                                    <div className="text-right">
                                        {numberWithCommas(v.value, 2)}
                                    </div>
                                );
                        }
                    },
                ]
            },
            {
                Header: 'O/S Amount',
                accessor: '',
                rowSpan: '2',
                columns: [
                    {
                        Header: '',
                        accessor: 'ctrt_os_value',
                        displayNone: true,
                        Cell: (v: any) => {
                                return (
                                    <div className="text-right">
                                        {numberWithCommas(v.value, 2)}
                                    </div>
                                );
                        }
                    },
                ]
            },
            {
                Header: 'Accrual O/S Interest',
                accessor: '',
                rowSpan: '2',
                columns: [
                    {
                        Header: '',
                        accessor: 'ctrt_os_interest',
                        displayNone: true,
                        Cell: (v: any) => {
                                return (
                                    <div className="text-right">
                                        {numberWithCommas(v.value, 2)}
                                    </div>
                                );
                        }
                    },
                ]
            },
            {
                Header: 'Amount(MYR)',
                accessor: '',
                rowSpan: '2',
                columns: [
                    {
                        Header: '',
                        accessor: 'ctrt_value_baseccy',
                        displayNone: true,
                        Cell: (v: any) => {
                                return (
                                    <div className="text-right">
                                        {numberWithCommas(v.value, 2)}
                                    </div>
                                );
                        }
                    },
                ]
            },
            {
                Header: 'O/S Amount(MYR)',
                accessor: '',
                rowSpan: '2',
                columns: [
                    {
                        Header: '',
                        accessor: 'ctrt_os_value_baseccy',
                        displayNone: true,
                        Cell: (v: any) => {
                                return (
                                    <div className="text-right">
                                        {numberWithCommas(v.value, 2)}
                                    </div>
                                );
                        }
                    },
                ]
            },
            {
                Header: 'O/S Interest(MYR)',
                accessor: '',
                rowSpan: '2',
                columns: [
                    {
                        Header: '',
                        accessor: 'ctrt_os_interest_baseccy',
                        displayNone: true,
                        Cell: (v: any) => {
                            return (
                                <div className="text-right">
                                    {numberWithCommas(v.value, 2)}
                                </div>
                            );
                        }
                    },
                ]
            },
       
        ],
        []
    );

    const handleOpenFile = (row:any) => {

        const latestFilterParams = filterParamsRef.current; 
       // alert(JSON.stringify(latestFilterParams))
        //console.log('row',row)
        //let file_path = row.ctrt_filepath;
        //let a_code = row.a_code;
        //console.log("filterParams",filterParams)
        let accounts = latestFilterParams["accounts[]"] ||[];
        let url = `/api/client/account/${accounts}/contract/${row.ctrt_id}/file`;

        window.open(url, '_blank');
    }


    return (
        <>
            <ReactTable
                // headerStyle={{
                //     background: 'rgba(210, 209, 209, 1)',
                //     color:"black"
                // }}
                columns={tblColumns}
                data={tableData}
                loading={loading}
                size='small'
                borderSeparate={true}
                pageSize={10}
                currentPage={tablePagination.currentPage}
                totalRecords={tablePagination.totalRecords}
                pageChange={(cPage: number) => {
                    // showNotiLoader();
                    requestTableData(accounts, cPage,inputs);
                }}
                hasPagination
                Footer={
                    summary&&
                    <>
                        <div className='p-2'>
                            {/* {
                                JSON.stringify(summary)
                            } */}
                            <div className=''><b>O/S Amount (MYR): {
                                numberWithCommas( summary?.os_value_baseccy, 2)
                            } </b></div>
                            <div className=''><b>Amount (MYR): {
                                numberWithCommas( summary?.value_baseccy, 2)
                            } </b></div>
                        </div>
                    </>
                }
            />
  
        </>
    );
};

export default PurchaseSalesTbl;
